export const basicClasses = {
    container: {
        display: 'inline-flex',
        alignItems: 'baseline',
        fontSize: 'inherit'
    },
    hotelNameWrap: {
    },
    hotelCategory: {
        display: 'inline-flex',
        alignItems: 'baseline',
        marginRight: 8,
    },
    hotelName: {
        marginRight: 16
    },
    linksContainer: {
        color: '#0087be',
        fontWeight: 400,
        whiteSpace: 'nowrap'
    },
    link: {
        color: '#0087be',
        textDecoration: 'none',

        '&:hover': {
            color: '#00c3ff'
        }
    },
    h1Text: {
        fontSize: '1em',
        margin: 0,
        display: 'inline-block'
    }
};

export type ThemeClasses = JSSClasses<typeof basicClasses>;
